import React, { useContext } from 'react';
import { Button } from 'antd';

interface IProps {
  current: number;
  setCurrent: (c: number) => void;
  onSave: () => void;
  onNext: (f: () => void) => void;
  onPrev: () => void;
  saving: boolean;
}

const Buttons = ({ current, setCurrent, onSave, onNext, onPrev, saving }: IProps) => {
  const next = () => {
    onNext(() => setCurrent(1));
  };
  const prev = () => {
    setCurrent(0);
    onPrev();
  };

  return (
    <div>
      {current === 0 && <Button onClick={next}>Next</Button>}
      {current === 1 && <Button onClick={prev}>Prev</Button>}
      <Button type="primary" onClick={onSave}>
        {saving ? 'Saving' : 'Save'}
      </Button>
    </div>
  );
};

export default Buttons;
